<section class="animated fadeIn bg-gray ">
    <div class="breadcrumbArea">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="/approval"> <i class="hdr-home"></i> </a></li>
                            <li class="breadcrumb-item active" aria-current="page">Initiate Delegation Request</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>

    <section class="height-calc">
        <div class="container mt-24 mb30">
            <div class="row">
                <div class="col-md-3 col-sm-3 mb-24">
                    <p class="appHead f-18 mb-12">Select Application(s)</p>
                    <div class="whiteBox2">
                        <div class="selecteDiv2">
                            <p class="appSelchead">{{NoOfSelectedApp}} Application Selected</p>
                            <ul class="selUl" (click)="RemoveSelectedApp($event)">
                                <li *ngFor='let app of selectedApps'>{{app.AppName|uppercase}}</li>
                            </ul>
                        </div>
                        <p class="appSelchead bt-1">Application List</p>
                        <div class="leftSelectAll">
                            <ul class="selectRow">
                                <li>
                                    <label class="checkbox-label-role customLabel">
                                        <input type="checkbox" class="check1" [(ngModel)]="isCheckAllApp"
                                            (change)="CheckAllApplication($event)">
                                        <span class="checkbox-custom">Select All</span>
                                        <span class="customCheck"></span>
                                    </label>
                                </li>
                                <li *ngFor='let appRole of appRoleAndSubRoles'>
                                    <label class="checkbox-label-role customLabel">
                                        <input type="checkbox" value="{{appRole.AppId}}"
                                            (change)="onSelectApp(appRole.AppName)">
                                        <span class="checkbox-custom">{{appRole.AppName|uppercase}}</span>
                                        <span class="customCheck"></span>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-9" [hidden]="!noData">
                    <div class="noRecored">
                        <div class="norecoredContent">
                            <img src="../../../assets/images/icon.png" alt="" class="">
                            <h4>No application selected</h4>
                            <p>Please select one or more application(s) to submit request</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-9 col-sm-9" [hidden]="!addApps" >
                    <!-- Provide Application wise Details -->
                    <div class="row">
                        <div class="col-md-4 col-sm-4">
                            <p class="appHead f-18  mb-12">Provide Application wise Details</p>
                        </div>
                        <div class="col-md-8 col-sm-8">
                            <ul class="sameUl">
                                <li>Same for All:</li>
                                <li>
                                    <label class="checkbox-label">
                                        <input type="checkbox" (click)="toggleDelegate()">
                                        <span class="checkbox-custom mr-t-2"></span>
                                        <h4 class="checkText">Delegate to </h4>
                                    </label>
                                </li>
                                <li>
                                    <label class="checkbox-label ">
                                        <input type="checkbox" (click)="toggleDuration()">
                                        <span class="checkbox-custom mr-t-2"></span>
                                        <h4 class="checkText"> Duration </h4>
                                    </label>
                                </li>
                                <li>
                                    <label class="checkbox-label">
                                        <input type="checkbox" (click)="toggleRemarks()">
                                        <span class="checkbox-custom mr-t-2"></span>
                                        <h4 class="checkText"> Remarks </h4>
                                    </label>
                                </li>
                                <li>
                                    <p class="expColText" (click)="openAll()">
                                        <!-- <span (click)="txtTgl = !txtTgl">{{txtTgl ? "Collapse All" : "Expand All"}}</span> -->
                                        <span class="hdr-accordionDown"></span>
                                        <span class="hdr-accordionUp"></span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="padding0 accordionTab" *ngFor='let selectRole of selectedApps' >
                        <!-- Appliction with role -->
                        <p-accordion [activeIndex]="index"
                            expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-up">
                            <p-accordionTab [selected]="true">
                                <p-header class="headerA"> {{selectRole.AppName|uppercase}}
                                <span class="subHeader"> ( {{selectRole.NoOfSelectedRoleWithoutSubRole|| 0}} Roles selected) </span>
                                </p-header>
                                <!-- Without Sub roles -->
                                <ul class="provideDiv" *ngIf="!selectRole.IsAdvDelegated">
                                    <li>
                                        <label class="checkbox-label ">
                                            <input type="checkbox" [(ngModel)]="selectRole.SelectAllRoles"
                                                (change)="SelectAllRole($event,selectRole.AppId)">
                                            <span class="checkbox-custom"></span>
                                            <h4 class="checkText tableHd"> Roles <span> (without Sub-Roles) </span> </h4>
                                        </label>
                                        <ul class="selectRow mb-30">
                                            <li *ngFor='let role of selectRole.CDS_GetRoleAndSubRole;let i=index'>
                                                <label class="checkbox-label-role customLabel">
                                                    <input type="checkbox" [name]="'mes_' + i" [(ngModel)]="role.checkapp"
                                                        (change)="addRoleEvent(role.AppId,role.AppRoleID)">
                                                    <span class="checkbox-custom">{{role.RoleName|uppercase}}</span>
                                                    <span class="customCheck mrt-1"></span>
                                                </label>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <!-- With Sub Roles -->
                                <ul class="provideDiv" *ngIf="selectRole.IsAdvDelegated">
                                    <li *ngFor='let subrole of selectRole.CDS_GetRoleAndSubRole;let p=index'>
                                        <h4 class="checkText tableHd rolesHead"> Roles <span> (along with Sub-Roles) </span>
                                            <i class="icon-info p-r-t-1" triggers="mouseenter:mouseleave" placement="bottom"
                                                container="body" [popover]="subRoleTemp"></i>
                                        </h4>
                                        <label class="checkbox-label">
                                            <!-- <input type="checkbox" [(ngModel)]="SelectAllSubRoles" (change)="SelectAllWithSubRole(subrole.SubRoleName)"> -->
                                            <input type="checkbox" name="'subRole_' + p" [(ngModel)]="subrole.SelectAllRoles"
                                                (change)="SelectAllWithSubRole($event,subrole.AppId,subrole.AppRoleID)">
                                            <span class="checkbox-custom"></span>
                                            <h4 class="checkText tableHd grpLb"> {{subrole.RoleName|uppercase}} </h4>
                                        </label>
                                        <ul class="selectRow mb-30">
                                            <li *ngFor='let subsubrole of subrole.SubRoleName;let k=index'>
                                                <label class="checkbox-label-role customLabel">
                                                    <input type="checkbox" [name]="'subsubrole' + k"
                                                        [(ngModel)]="subsubrole.checkapp"
                                                        (change)="addSubRoleEvent(subsubrole.AppId,subsubrole.RollId,subsubrole.Subrolid,subsubrole.SubRoleName,subsubrole.SubRoleCode)">
                                                    <span class="checkbox-custom">
                                                        {{subsubrole.SubRoleName}}
                                                    </span> <span class="customCheck mrt-1"></span> </label>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
    
                                <div class="bootomSection">
                                    <div class="row">
                                        <div class="col-md-4" [class.delegateHide]="delegateHideDiv">
                                            <label class="custom-label">Delegate To</label>
                                            <div class="empSearch FormField2">
                                                <p-autoComplete [(ngModel)]="searchText" [suggestions]="filteredBrands"
                                                    (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1"
                                                    placeholder="Search by Name or SAP ID" panelStyleClass="panelClass"
                                                    (onDropdownClick)="OnClickDelegative($event)"
                                                    (onKeyUp)="OnKeyUpDelegative($event,selectRole?.AppId)"
                                                    (onSelect)="updateAdvanceDelegatee($event,selectRole?.AppId)">
                                                </p-autoComplete>
                                                <span class="hdr-search"></span>
                                                <ng-template let-brand pTemplate="item">
                                                    <div class="ui-helper-clearfix">
                                                        <div>{{brand}}</div>
                                                    </div>
                                                </ng-template>
                                                <label *ngIf="ValidationSelectDelegetee" style="color: red;">*Select
                                                    Delegatee</label>
                                            </div>
                                        </div>
    
                                        <div class="col-md-8 col-sm-8 cstmDD calender"
                                            [class.durationHide]="durationHideDiv">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label class="custom-label">Duration</label>
                                                    <div class="radioWarp">
                                                        <div class="d-flex align-items-center radioBtn">
                                                            <p-radioButton name="Duration" value="1-Month"
                                                                [(ngModel)]="ingredient" inputId="ingredient1"
                                                                (onClick)="onDatesRangeFilterSelected()">
                                                            </p-radioButton>
                                                            <label for="ingredient1" class="">1 Month</label>
                                                        </div>
    
                                                        <div class="d-flex align-items-center radioBtn">
                                                            <p-radioButton name="Duration" value="3-Month"
                                                                [(ngModel)]="ingredient" inputId="ingredient2"
                                                                (onClick)="onDatesRangeFilterSelected()">
                                                            </p-radioButton>
                                                            <label for="ingredient2" class="">3 Month</label>
                                                        </div>
    
                                                        <div class="d-flex align-items-center radioBtn">
                                                            <p-radioButton name="Duration" value="1-Year"
                                                                [minDate]="minDate" [(ngModel)]="ingredient"
                                                                inputId="ingredient3"
                                                                (onClick)="onDatesRangeFilterSelected()">
                                                            </p-radioButton>
                                                            <label for="ingredient3" class="">1 Year</label>
                                                        </div>
    
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="FormField calenderFild mt-26">
                                                        <p-calendar appendTo="body" dateFormat="dd-M-y" [numberOfMonths]="2"
                                                            [(ngModel)]="AdvanceDateRangeFilter" selectionMode="range"
                                                            [readonlyInput]="true" [showIcon]="true" (onSelect)="moveDate()"></p-calendar>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-16" [class.remarksHide]="remarksHideDiv">
                                        <div class="col-md-12" >
                                            <div class="form-area text-center">
                                                <textarea class="form-control remarks"
                                                    placeholder="Due to non-availability in office."
                                                    (change)="onAdvanceRemarks($event.target.value,selectRole.AppId)"></textarea>
                                                <div class="mickWarp"><span class="hdr-mick"></span></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-16">
                                        <div class="col-md-12">
                                            <div class="form-area text-center">
                                                <label class="checkbox-label ml-0">
                                                    <input type="checkbox" class="check1" [(ngModel)]="DelegatorChecked"
                                                        (change)="onDelegatorchecked($event.target.checked)">
                                                    <span class="checkbox-custom mr-l-10"></span>
                                                    <h4 class="checkText tableHd ml-8">I agree, Delegator will continue to be
                                                        responsible for all actions taken by Delegatee</h4>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col-md-12 mt-16 mb-24">
                                            <label class="checkbox-label ml-0">
                                                <input type="checkbox" class="check1" [(ngModel)]="DelegatorChecked"
                                                    (change)="onDelegatorchecked($event.target.checked)">
                                                <span class="checkbox-custom"></span>
                                                <h4 class="checkText tableHd ml-8">I agree, Delegator will continue to be
                                                    responsible for all actions taken by Delegatee</h4>
                                            </label>
                                        </div>
                                    </div> -->
                                    <!-- <div>
                                        <label *ngIf="DelegatorConsen" style="color: hsl(0, 100%, 50%);">*Provide Delegator
                                            Consent</label>
                                    </div> -->
                                </div>
    
                            </p-accordionTab>
                        </p-accordion>
                    </div>
    
                    <div class="whiteBox pdBox mt30 mb-30" style="display: none;" [class.delegateCurrent]="delegateToggled"
                        [class.durationCurrent]="durationToggled" [class.remarksCurrent]="remarksToggled" >
                        <div class="row">
                            <div class="col-md-4 delegateShow">
                                <label class="custom-label">Delegate To</label>
                                <div class="empSearch FormField2">
                                    <p-autoComplete [(ngModel)]="searchText" [suggestions]="filteredBrands"
                                        (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1"
                                        placeholder="Search by Name or SAP ID" panelStyleClass="panelClass"
                                        (onDropdownClick)="OnClickDelegative($event)"
                                        (onKeyUp)="OnKeyUpDelegativeToggle($event)"
                                        (onSelect)="updateAdvanceDelegateeToggle($event)">
                                    </p-autoComplete>
                                    <span class="hdr-search"></span>
                                    <ng-template let-brand pTemplate="item">
                                        <div class="ui-helper-clearfix">
                                            <div>{{brand}}</div>
                                        </div>
                                    </ng-template>
                                    <!-- <label *ngIf="ValidationSelectDelegetee" style="color: red;">*Select Delegatee</label> -->
                                </div>
                            </div>
                            <div class="col-md-8 col-sm-8 cstmDD calender durationShow">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="custom-label">Duration</label>
                                        <div class="radioWarp">
                                            <div class="d-flex align-items-center radioBtn">
                                                <p-radioButton name="Duration" value="1-Month" [(ngModel)]="ingredient"
                                                    inputId="ingredient1"></p-radioButton>
                                                <label for="ingredient1" class="">1 Month</label>
                                            </div>
    
                                            <div class="d-flex align-items-center radioBtn">
                                                <p-radioButton name="Duration" value="3-Month" [(ngModel)]="ingredient"
                                                    inputId="ingredient2"></p-radioButton>
                                                <label for="ingredient2" class="">3 Month</label>
                                            </div>
    
                                            <div class="d-flex align-items-center radioBtn">
                                                <p-radioButton name="Duration" value="1-Year" [(ngModel)]="ingredient"
                                                    inputId="ingredient3"></p-radioButton>
                                                <label for="ingredient3" class="">1 Year</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="FormField calenderFild mt-26">
                                            <p-calendar appendTo="body" dateFormat="dd-M-y" [numberOfMonths]="2"
                                                [(ngModel)]="AdvanceDateRangeFilter" selectionMode="range"
                                                [readonlyInput]="true" [showIcon]="true" (onSelect)="moveDate()"></p-calendar>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-sm-12 cstmDD remarksShow mt-20">
                                <label class="custom-label">Remarks</label>
                                <div class="form-area text-center">
                                    <textarea class="form-control remarks" placeholder="Due to non-availability in office." [(ngModel)]="advancedRemarks"
                                        (change)="onAdvanceRemarksToggle($event.target.value)"></textarea>
                                    <div class="mickWarp"><span class="hdr-mick"></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                </div>
            </div>
        </div>
    </section>
   
</section>


<div class="text-center glb-btn pb-24 pt-24 pos-sticky border-t-1-gray">
    <button class="btn secondry-button" (click)="reloadWindow()">Cancel</button>
    <button (click)="onSubmit();" type="button" class="btn primary-button"
        [disabled]="! isSubmitbuttonshow">Submit</button>
    <!-- <button (click)="rejectModal.show();onSubmit();" type="button" class="btn primary-button" [disabled]="! isSubmitbuttonshow">Submit</button> -->
</div>

<!-- Roles Popover  -->
<ng-template #revokeTemplate>
    <div class="Revoke provideDiv">
        <ul class="selectRow">
            <li>
                <label class="checkbox-label-role">
                    <input type="checkbox">
                    <span class="checkbox-custom">
                        CORP-HR-HEAD
                    </span> </label>
            </li>
            <li>
                <label class="checkbox-label-role">
                    <input type="checkbox">
                    <span class="checkbox-custom">
                        CUST-ROLE
                    </span> </label>
            </li>
            <li>
                <label class="checkbox-label-role">
                    <input type="checkbox">
                    <span class="checkbox-custom">
                        SBU-FIN
                    </span> </label>
            </li>
            <li>
                <label class="checkbox-label-role">
                    <input type="checkbox">
                    <span class="checkbox-custom">
                        FIN-SUPER
                    </span> </label>
            </li>
            <li>
                <label class="checkbox-label-role">
                    <input type="checkbox">
                    <span class="checkbox-custom">
                        FIN-REGION
                    </span> </label>
            </li>
        </ul>
    </div>
</ng-template>

<!-- along with Sub-Roles Popover info  -->
<ng-template #subRoleTemp>
    <div class="Revoke provideDiv">
        Check Role's and Application.
    </div>
</ng-template>




<!-- Reject Modal Box Start  -->
<div bsModal #rejectModal="bs-modal" class="modal fade myModal" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-body d-flex justify-content-center">
                <div class="mCell text-center">
                    <span class="alertIcon"> <i class="hdr-attention"></i> </span>
                    <h3>Are you sure you want to submit request?</h3>
                    <div class="glb-btn mt-40">
                        <button (click)="rejectModal.hide();" class="btn secondry-button">No</button>
                        <button type="button" class="btn primary-button"
                            (click)="rejectModal.hide(); dataSubmitfunction();">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Approve Modal Box Start  -->
<ng-template #approvedModal>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="sucImg" /> </span>
            <!-- <pre [innerHTML]="reqStatusRemarks | safe: 'html'"></pre> -->
            <p *ngFor='let message of reqStatusRemarks;'>{{message}}</p>
             <!-- <p>{{reqStatusRemarks}}</p> -->
        </div>
    </div>
</ng-template>

<ng-template #alertSuccErrorModal>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="alertImg" /> </span>
            <!-- <pre [innerHTML]="errorOndehalfDelegation | safe: 'html'"></pre> -->
             <p>{{errorOndehalfDelegation}}</p>
        </div>
    </div>
</ng-template>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>


<ng-container *ngIf="visible">
    <div class="toast-warp" #quick>
        <p>{{errorOnAdvDelegation}}</p>
        <button (click)="quick.hidden = !quick.hidden;OnClick()" type="button" aria-label="Close"
            class="btn-close close pull-right"><span aria-hidden="true" ></span></button>
    </div>
</ng-container>

<ng-template #alertSuccErrorModalMultiLine>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="alertImg" /> </span>
            <!-- <pre [innerHTML]="errorOndehalfDelegation | safe: 'html'"></pre> -->
             <p *ngFor='let message of errorOndehalfDelegationMultiError;'>{{message}}</p>
        </div>
    </div>
</ng-template>